// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4039":"b59d9894","7130":"6b3c782f","9594":"7deca895"}[chunkId] + ".chunk.css";
};